
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexCmGu5fPwfHzyrhDRstL5QmgkYDnUb5dgBde_zI_js6AMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/index.vue?macro=true";
import { default as debugVT6y15jvB6oMw_5BuhqSKlSwUyzPoTdEgyNFrL6k374Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/debug.vue?macro=true";
import { default as loginD_2Dz_yspDt6TqAiAA_TmuHmtrJsHaxu_m5QX7mL6UMMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/login.vue?macro=true";
import { default as signupt2m9Libk_YN1GK5E26urPoNW2K8EyULY_Tw5KYPy5wkMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/signup.vue?macro=true";
import { default as forgotPasswordTckXiNEprC1eRGcE0bL9h_fzGVCI7prLNDC3zaIVcAcMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/forgotPassword.vue?macro=true";
import { default as resetPasswordA71x_CpIv2IGu7eukHMDaqtEZMzhOElnfKJ_T6_KxvQMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/resetPassword.vue?macro=true";
import { default as changeEmaillLGCXru7EkibLxy8l__4mKE8fB3rxK1MAfte3hmECisMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/changeEmail.vue?macro=true";
import { default as verifyEmailAddressRIdt2LCzxvEaMZQujMu_yjDH1JPdfUgS17HJLTBBu50Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/verifyEmailAddress.vue?macro=true";
import { default as styleGuideHIM5LQyMIPzzR6PnWie4GrjtawNbNcFYjimsC65fKN8Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/styleGuide.vue?macro=true";
import { default as loginWithSAMLXXyVwUi1A57EhhRzaSRSpjd3xNnjUWRSSCuUGWtGW6UMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue?macro=true";
import { default as loginErrorSX2XCSEUx7LHvISl198TPJYVqJLWz3r1tOfRd0Z_yVoMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue?macro=true";
import { default as loginPagesIZk5mEQ9kXNeX0UUQqlxDkIoPiU6xaenZoZzulMkg90Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/loginPages.vue?macro=true";
import { default as dashboardN6UN6TgWa7ijVzIONLBMraHY8KVedr92C5IWLkImA1EMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/dashboard.vue?macro=true";
import { default as workspaceWFzHOIj_BKndjsVl6AK8COudoIwSe4v9XB2iIbv0bx8Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/workspace.vue?macro=true";
import { default as settingsydwfzbxZoG29DyJKI7Xm1PgzL9zuyzk9tzs87Vgq6MMMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/settings.vue?macro=true";
import { default as healthjcgzCHvCU26i0Uza_tu3M2Vfwtm7SeRSCrDWOAT6MK0Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/health.vue?macro=true";
import { default as dashboardqIIZwIEjSGu9bvJhssatDFJIx96b0v4G0dO94LD8aNYMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/dashboard.vue?macro=true";
import { default as users7favi94R2aWq4EDceOG_t_71Vel2KkCCEAcNzQAU7OIMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/users.vue?macro=true";
import { default as workspaces_NNHb7YiNC2lvVWxR9_9KyYpM0IY6jEnmDHSIRPAj20Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/workspaces.vue?macro=true";
import { default as membersSkWwR2d4exfhY9IsKXKuy1tpS1WoteXBaaTnBt6qjOkMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/settings/members.vue?macro=true";
import { default as invites9fyZQeb240SlbHTZ0YVAgGBBbm7u2dE9TdQFGnhjSIkMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/settings/invites.vue?macro=true";
import { default as teamsX46WY9auWPjXk2dewVTvgMyopdCy3Oseu1owIUfMRYUMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue?macro=true";
import { default as settingsIcv0F8phJI5Gaznf_hg2QzJl8GdXVc21xS9ZxfiKoNoMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/settings.vue?macro=true";
import { default as authProvidersNNlcjLMkgbiNIODHiU_MuSQpmksewOlvx9Kw4OchlJwMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue?macro=true";
import { default as auditLogzRF9r0EevUJxdUoDkgmWDaczJnvzA_TDjmFT3byawiEMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue?macro=true";
import { default as scansBzX_4PHpYwhVl5zmnKNnrWacLWLGrqS_JX6DRy5pOdoMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/scans.vue?macro=true";
import { default as resultsZyEZvrCM2aQUxQmtCrVU2cx9Lott5bSKS5A8vRMKOS4Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/results.vue?macro=true";
import { default as dataScannerVpOuVvtsqXcWXLv6ncod8GYgDRQuyTS5uxMr2sNTHTYMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner.vue?macro=true";
import { default as rootERZw9kZDV3oIUNVcZJPxRqjwOpBx7H8ddlZO8TIkfd8Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/root.vue?macro=true";
import { default as workspaceInvitationPiFvXgF2Emod_7tJqR_UmNu1C73aeVD6l1qsbk9IcG0Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/workspaceInvitation.vue?macro=true";
import { default as templateCHTq7zh0o5bczvS8JUDBwOBtHk4wjQoCiJW36I_l13gMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/template.vue?macro=true";
import { default as _health43Y5Qho3g7J9xOMMrnL9yyGUAnLaVlhyadyJ0m7syYwMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/_health.vue?macro=true";
import { default as notificationRedirectq537zxqckfHDTfBsORV_IZm0QiyZhtFD2FNewFQdWYEMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/notificationRedirect.vue?macro=true";
import { default as onboardingkYu3B8453OwVWUlV1bS23iWk9nZq4H0ypiLVv_v9KloMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/onboarding.vue?macro=true";
import { default as RouterViewPlaceholdereFIXZ6wCDRt5Z22vP9XVvC9Fuuf8kAuA0PKgfKr5smMMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/components/RouterViewPlaceholder.vue?macro=true";
import { default as webhooksCUScY994Rh_hg4WPDkqEygwPcjaSFiOVrz4GkANC_NQMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/table/webhooks.vue?macro=true";
import { default as configureDataSyncjw5yCfxK9mwc6CP_MReXBC_8pdyuixySAdzFBlDb6ngMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/table/configureDataSync.vue?macro=true";
import { default as table2rQzqpO5HN9Fm48L6KPlxboKvlCuFYJzrQZyclHEFvEMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/table.vue?macro=true";
import { default as APIDocsi2jw2IpNtGnbhlbTWlo6vwXbKtHE5D4JYQ2nkBPaIH8Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/APIDocs.vue?macro=true";
import { default as APIDocsDatabaseaiHc3S3x6osyaCDw4O7wutTKK_spgHidxqDdYzXXy_AMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/APIDocsDatabase.vue?macro=true";
import { default as formuLLF2JubtOTvElHu9O0o0ynCrAM6G9sJT2AsZXusuakMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/form.vue?macro=true";
import { default as publicView4zZbe8IiXkW72D1zy34M1BTU0fMlYPxZJyJfRe4NyKcMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/publicView.vue?macro=true";
import { default as publicViewLoginNQ4f8CrVG0W3zWKpJ__EsJOEzMDYM5BITSiBo3FJMVQMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/publicViewLogin.vue?macro=true";
import { default as dashboard38tR_Tdr013YazvFpZskuASoP7hlbePqXlNsJKSS45wMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/dashboard/pages/dashboard.vue?macro=true";
import { default as pageEditorrkfIEo1ieKka2o6qGzJYqA1P6JMbLKHtOncN_t7opCUMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/builder/pages/pageEditor.vue?macro=true";
import { default as publicPageriDv7hBy1YvrauaEDufIpF1cB_u4EafljsM5QdPSCNUMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/builder/pages/publicPage.vue?macro=true";
import { default as automationWorkflowbXtC2mv8O1fCOmHYDARNzlsUY0ys1r8JyjdWPMdijMkMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/automation/pages/automationWorkflow.vue?macro=true";
import { default as licensesfH2UdwJ3jvrUZ6BNTENDaplSqAwo7Usddbk_lR8q7LgMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue?macro=true";
import { default as licenseU2AFA7F_KwjBCYRnDXMjqMiyZ9OQ6sji8wqLoMYnEFkMeta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue?macro=true";
import { default as rootZyWPsYuwj1pXvbDk4VDclN_8gElvz65Fgr6LmSyvLZ8Meta } from "/home/runner/work/baserow-zh-build/baserow-zh-build/src/premium/web-frontend/modules/baserow_premium/pages/root.vue?macro=true";
import { default as publicViewic0BLFnKa9D79LeCccGHGRa0RQ5dtQAxboPDW3rHy9wMeta } from "@baserow/modules/database/pages/publicView.vue?macro=true";
export default [
  {
    name: "index",
    path: "",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/index.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/debug.vue")
  },
  {
    name: "login-pages",
    path: "",
    meta: { ...(loginPagesIZk5mEQ9kXNeX0UUQqlxDkIoPiU6xaenZoZzulMkg90Meta || {}), ...{"middleware":["settings","urlCheck","settings","urlCheck"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/loginPages.vue"),
    children: [
  {
    name: "login",
    path: "/login",
    meta: { ...(loginD_2Dz_yspDt6TqAiAA_TmuHmtrJsHaxu_m5QX7mL6UMMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signupt2m9Libk_YN1GK5E26urPoNW2K8EyULY_Tw5KYPy5wkMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/signup.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgotPasswordTckXiNEprC1eRGcE0bL9h_fzGVCI7prLNDC3zaIVcAcMeta || {},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/forgotPassword.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/resetPassword.vue")
  },
  {
    name: "change-email",
    path: "/change-email/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/changeEmail.vue")
  },
  {
    name: "verify-email-address",
    path: "/verify-email-address/:token",
    meta: verifyEmailAddressRIdt2LCzxvEaMZQujMu_yjDH1JPdfUgS17HJLTBBu50Meta || {},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/verifyEmailAddress.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/styleGuide.vue")
  },
  {
    name: "login-saml",
    path: "/login/saml",
    meta: loginWithSAMLXXyVwUi1A57EhhRzaSRSpjd3xNnjUWRSSCuUGWtGW6UMeta || {},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue")
  },
  {
    name: "login-error",
    path: "/login/error",
    meta: loginErrorSX2XCSEUx7LHvISl198TPJYVqJLWz3r1tOfRd0Z_yVoMeta || {},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue")
  }
]
  },
  {
    name: "root",
    path: "",
    meta: { ...(rootERZw9kZDV3oIUNVcZJPxRqjwOpBx7H8ddlZO8TIkfd8Meta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/root.vue"),
    children: [
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardN6UN6TgWa7ijVzIONLBMraHY8KVedr92C5IWLkImA1EMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/dashboard.vue")
  },
  {
    name: "workspace",
    path: "/workspace/:workspaceId",
    meta: { ...(workspaceWFzHOIj_BKndjsVl6AK8COudoIwSe4v9XB2iIbv0bx8Meta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","settings","authenticated","impersonate","workspacesAndApplications"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/workspace.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/settings.vue")
  },
  {
    name: "admin-health",
    path: "/admin/health",
    meta: { ...(healthjcgzCHvCU26i0Uza_tu3M2Vfwtm7SeRSCrDWOAT6MK0Meta || {}), ...{"middleware":"staff"} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/health.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/dashboard.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/users.vue")
  },
  {
    name: "admin-workspaces",
    path: "/admin/workspaces",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/admin/workspaces.vue")
  },
  {
    name: "settings",
    path: "/workspace/:workspaceId/settings",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/settings.vue"),
    children: [
  {
    name: "settings-members",
    path: "members",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/settings/members.vue")
  },
  {
    name: "settings-invites",
    path: "invites",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/settings/invites.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue")
  }
]
  },
  {
    name: "admin-auth-providers",
    path: "/admin/auth-providers",
    meta: { ...(authProvidersNNlcjLMkgbiNIODHiU_MuSQpmksewOlvx9Kw4OchlJwMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue")
  },
  {
    name: "admin-audit-log",
    path: "/admin/audit-log",
    meta: { ...(auditLogzRF9r0EevUJxdUoDkgmWDaczJnvzA_TDjmFT3byawiEMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  },
  {
    name: "admin-data-scanner",
    path: "/admin/data-scanner",
    meta: { ...(dataScannerVpOuVvtsqXcWXLv6ncod8GYgDRQuyTS5uxMr2sNTHTYMeta || {}), ...{"middleware":"staff"} },
    redirect: "/admin/data-scanner/scans",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner.vue"),
    children: [
  {
    name: "admin-data-scanner-scans",
    path: "scans",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/scans.vue")
  },
  {
    name: "admin-data-scanner-results",
    path: "results",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/results.vue")
  }
]
  },
  {
    name: "workspace-audit-log",
    path: "/workspace/:workspaceId/audit-log",
    meta: { ...(auditLogzRF9r0EevUJxdUoDkgmWDaczJnvzA_TDjmFT3byawiEMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  }
]
  },
  {
    name: "workspace-invitation",
    path: "/workspace-invitation/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/workspaceInvitation.vue")
  },
  {
    name: "template",
    path: "/template/:slug",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/template.vue")
  },
  {
    name: "health-check",
    path: "/_health/:trailing()?",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "notification-redirect",
    path: "/notification/:workspaceId/:notificationId",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/notificationRedirect.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingkYu3B8453OwVWUlV1bS23iWk9nZq4H0ypiLVv_v9KloMeta || {},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/onboarding.vue")
  },
  {
    name: "database-table",
    path: "/database/:databaseId/table/:tableId/:viewId?",
    meta: { ...(table2rQzqpO5HN9Fm48L6KPlxboKvlCuFYJzrQZyclHEFvEMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs","settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/table.vue"),
    children: [
  {
    name: "database-table-row",
    path: "row/:rowId",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/components/RouterViewPlaceholder.vue")
  },
  {
    name: "database-table-open-webhooks",
    path: "webhooks",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/table/webhooks.vue")
  },
  {
    name: "database-table-open-configure-data-sync",
    path: "configure-data-sync/:selectedPage?",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/table/configureDataSync.vue")
  }
]
  },
  {
    path: "/api/docs",
    name: "database-api-docs-redirect",
    redirect: "/api-docs"
  },
  {
    path: "/api/docs/database/:databaseId",
    name: "database-api-docs-details-redirect",
    redirect: "/api-docs/database/:databaseId"
  },
  {
    name: "database-api-docs",
    path: "/api-docs",
    meta: { ...(APIDocsi2jw2IpNtGnbhlbTWlo6vwXbKtHE5D4JYQ2nkBPaIH8Meta || {}), ...{"middleware":["workspacesAndApplications","workspacesAndApplications"]} },
    alias: ["/api/docs"],
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/APIDocs.vue")
  },
  {
    name: "database-api-docs-detail",
    path: "/api-docs/database/:databaseId",
    meta: {"middleware":["workspacesAndApplications","workspacesAndApplications"]},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/APIDocsDatabase.vue")
  },
  {
    name: "database-table-form",
    path: "/form/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/form.vue")
  },
  {
    name: "database-public-grid-view",
    path: "/public/grid/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-gallery-view",
    path: "/public/gallery/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-view-auth",
    path: "/public/auth/:slug",
    meta: { ...(publicViewLoginNQ4f8CrVG0W3zWKpJ__EsJOEzMDYM5BITSiBo3FJMVQMeta || {}), ...{"layout":"login"} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/database/pages/publicViewLogin.vue")
  },
  {
    name: "dashboard-application",
    path: "/dashboard/:dashboardId",
    meta: { ...(dashboard38tR_Tdr013YazvFpZskuASoP7hlbePqXlNsJKSS45wMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","dashboardLoading","settings","authenticated","workspacesAndApplications","dashboardLoading"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/dashboard/pages/dashboard.vue")
  },
  {
    name: "builder-page",
    path: "/builder/:builderId/page/:pageId",
    meta: { ...(pageEditorrkfIEo1ieKka2o6qGzJYqA1P6JMbLKHtOncN_t7opCUMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/builder/pages/pageEditor.vue")
  },
  {
    name: "application-builder-page",
    path: "/:pathMatch(.*)*",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "builder-health-check",
    path: "/_health",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "application-builder-preview",
    path: "/builder/:builderId/preview/:pathMatch(.*)*",
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/:automationId/workflow/:workflowId",
    meta: { ...(automationWorkflowbXtC2mv8O1fCOmHYDARNzlsUY0ys1r8JyjdWPMdijMkMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceAutomationWorkflow","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceAutomationWorkflow","pendingJobs"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/modules/automation/pages/automationWorkflow.vue")
  },
  {
    name: "premium-root",
    path: "",
    meta: { ...(rootZyWPsYuwj1pXvbDk4VDclN_8gElvz65Fgr6LmSyvLZ8Meta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/premium/web-frontend/modules/baserow_premium/pages/root.vue"),
    children: [
  {
    name: "admin-licenses",
    path: "/admin/licenses",
    meta: { ...(licensesfH2UdwJ3jvrUZ6BNTENDaplSqAwo7Usddbk_lR8q7LgMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue")
  },
  {
    name: "admin-license",
    path: "/admin/license/:id",
    meta: { ...(licenseU2AFA7F_KwjBCYRnDXMjqMiyZ9OQ6sji8wqLoMYnEFkMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue")
  }
]
  },
  {
    name: "database-public-kanban-view",
    path: "/public/kanban/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-calendar-view",
    path: "/public/calendar/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-timeline-view",
    path: "/public/timeline/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  }
]